import React from "react"
import Moment from "../../moment"

const DateCell = ({ value }) => (value && value.length > 1 ? <Moment value={value} /> : "-")

export default DateCell
